import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PensionArrangement } from '../../Models/Models/Account/PensionArrangement';

declare var IS_RUNNING_IN_APP_POOL;

export class PensionArrangementClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, includeClosed: boolean): Promise<Array<PensionArrangement>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/PensionArrangement/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, includeClosed: includeClosed }

    return AjaxWrapper.get<Array<PensionArrangement>, any>(url, data);
  }
}

